import { createFileRoute } from "@tanstack/react-router";
import Intake from "@/components/intake/EntityTypeIntake";

export const Route = createFileRoute("/intake/")({
  head: () => ({
    meta: [
      { title: "Accelerate Now | Maven Scouts" },
      { name: "description", content: "Submit your company for consideration by Maven Scouts and the MavenWERX accelerator." },
      { property: "og:title", content: "Accelerate Now | Maven Scouts" },
      { property: "og:description", content: "Submit your company for consideration by Maven Scouts and the MavenWERX accelerator." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Intake,
});
